<button 
    mat-mini-fab 
    class="admin-theme"
    aria-label="Einstellungen öffnen" 
    (click)="openConfigDialog()">
    <mat-icon>settings</mat-icon>
</button>